import { render } from "./YearlyFour.vue?vue&type=template&id=4d926828"
import script from "./YearlyFour.vue?vue&type=script&lang=js"
export * from "./YearlyFour.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__